// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EVQns","title":"styles_title__vlCI1"};